<div mat-dialog-title>
    {{'Unread Notifications' | translate}}
</div>
<div mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="1vh">
        <div fxFlex *ngFor="let message of data.unread">
            <div *ngIf="message.caseId" (click)="gotoCase(message)" class="link">
                <span class="number">{{message.count}}</span>: {{message.caseName}}
            </div>
            <div *ngIf="!message.caseId" (click)="gotoNotifications(message)" class="link">
                <span class="number">{{message.count}}</span>: {{'Unrelated to a case' | translate}}
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <div fxLayout="row" fxFlex fxLayoutGap="0px">
        <div fxFlex align="right">
            <button class="red-text" mat-raised-button mat-dialog-close>
                {{ "Close" | translate }}
            </button>
        </div>
    </div>
</div>
